<template>
    <div class="modal fade" ref="investor_agreement_update_ref" id="investor_agreement_update">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" style="padding: 20px 20px 5px 20px !important">
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <h3 class="mb-0 pull-left"><b>Hey {{this.user.first_name}},</b></h3>
                        </div>
                        <div class="col-md-12 mb-3">
                            <p class="mb-2">
                                We hope you're enjoying your experience with Capsphere.
                            </p>
                            <p class="mb-2">
                                We've made some changes to enhance our user experience and to better serve you.
                            </p>
                            <p>
                                To continue using the platform, please review and accept the updated Investor Agreement 
                                ( <router-link :to="{name: 'tnc', params: {type: 'investor', compliant: 'conventional'}}" target="_blank" rel="noopener noreferrer">Conventional</router-link> and
                                    <router-link :to="{name: 'tnc', params: {type: 'investor', compliant: 'islamic'}}" target="_blank" rel="noopener noreferrer">Islamic</router-link> )
                                in compliance with the latest regulations. 
                            </p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer row" style="padding-bottom: 25px;">
                    <div class="col-md-12 d-flex flex-row justify-content-center">
                        <button @click.prevent="updateInvestorAgreement" class="btn btn-success pt-2 pb-2">Agree &amp; Continue</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'InvestorAgreementUpdateModal',
    props: {
        user: {
            type: Object,
        }
    },
    data () {
        return {
        }
    },
    created () {
        
    },
    methods: {
        updateInvestorAgreement() {
            axios.get('/api/investors/agreement/update')
                .then((res) => {
                    if (res.data.success === true) {
                        this.$emit('updateModalClose')
                        this.$noty.success('Successfully updated.')
                    }
                })
                .catch ((error) => {
                    this.$noty.error('Error! Please try again!')
                })
        },
    }
}
</script>
